import RadialGraph from './RadialGraph';

export default RadialGraph;
